<template>
    <v-container fluid v-if="this.$store.state.signedIn">
        <v-flex xs12 class="px-4 py-4">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        BGP Spotlight is currently undergoing planned maintenance
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-flex class="px-2 py-2">
                        <v-card>
                            <v-card-text>
                                While the BGP Spotlight system is undergoing maintenance, access to its features has been disabled.<br>
                                <br>
                                If you think you are seeing this notice in error, then please contact us.<br>
                                <br>
                                Thank you.
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>
    </v-container>
</template>

<script>

import info from '../../shared/operational/infopopout.vue';
import feedback from '../../shared/operational/feedback-window.vue';

export default {
  name: 'faq',
  components: {
      feedback
  },
  data () {
    return {
        qna: [
            
        ]
    };
  },
  mounted () {
  },
  beforeMount() {  
  },
  methods: {
    routeNewWindow: async function (input) {
        let routeData = this.$router.resolve({name: input});
        window.open(routeData.href, '_blank');
    }
  }
};
</script>
